export default !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/~/dom-helpers/esm/canUseDOM.js
// module id = TDnh
// module chunks = 22